import AppLayout from "components/layout/AppLayout";
import OnboardingView from "components/views/Onboarding";

const Onboarding = (props) => (
  <AppLayout hideNavigation>
    <OnboardingView {...props} />
  </AppLayout>
);

export default Onboarding;
